var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.701 8.414h-2.756c-.268 0-.375-.08-.375-.348.027-.965 0-1.903 0-2.867 0-.43-.187-.59-.588-.617h-.964c-.428 0-.615.188-.615.643v1.42c0 .456-.027.912 0 1.367.027.295-.054.402-.402.402-.91-.027-1.846 0-2.756 0-.508 0-.669.161-.669.67v.777c0 .563.16.724.696.724h2.73c.294 0 .4.053.4.402-.026.91 0 1.849 0 2.76 0 .509.161.67.67.67h.776c.562 0 .722-.161.722-.697v-2.76c0-.268.08-.375.348-.375.964.026 1.9 0 2.864 0 .428 0 .588-.188.615-.59v-.857c0-.536-.16-.697-.696-.724zM9.527 0C4.308 0 .027 4.287 0 9.486 0 14.711 4.255 19.052 9.473 19c5.192.08 9.5-4.234 9.527-9.46C19 4.315 14.745.028 9.527 0zM9.5 17.177c-4.148 0-7.68-3.537-7.68-7.69 0-4.128 3.532-7.665 7.68-7.665 4.121 0 7.734 3.537 7.627 7.69.134 4.127-3.48 7.665-7.627 7.665z",
    fill: "currentColor"
  })));
}

export default SvgPlus;